// extracted by mini-css-extract-plugin
export default {"wrapper":"Checkbox_wrapper__OFhdz","checkbox":"Checkbox_checkbox__2CTPm"};